import axios from "axios";

const baseURL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL,
  withCredentials: true,
});

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const config = error.config || {};
    if (!error.response) {
      config.__netRetries = (config.__netRetries || 0) + 1;
      if (config.__netRetries <= 2) {
        await new Promise((r) => setTimeout(r, 1200 * config.__netRetries));
        return api(config);
      }
      return Promise.reject(error);
    }
    if (error.response.status === 401 && !config.__refreshed && config.url && !config.url.includes("/auth/")) {
      config.__refreshed = true;
      try {
        await axios.post(`${baseURL}/auth/refresh`, {}, { withCredentials: true });
        return api(config);
      } catch {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
